import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Box, useTheme } from '@mui/material';

export default function CustomDialog({ isOpen, handleClose, title, action, maxWidth, children, width, padding, paid }) {
    const theme = useTheme()
    return (
        <Dialog
            onClose={(e, reason) => {
                if (reason === 'backdropClick') return;
                handleClose();
            }}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            PaperProps={{
                sx: { width: width, padding: padding || "5px 5px" },
            }}
            maxWidth={maxWidth}
            fullWidth
            disableEscapeKeyDown
        >
            <DialogTitle fontSize={'17px'} sx={{ m: 0, p: 0.5, color: theme?.palette?.primary?.main, display: "flex", alignItems: "center", justifyContent: "space-between" }} id="customized-dialog-title">
                {title}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                // sx={(theme) => ({ position: 'absolute', right: 9, color: theme.palette.grey[500], top: -3 })}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ padding: "10px 10px", border: 'none' }}>
                {children}
            </DialogContent>
            <DialogActions sx={{ padding: 0, width: '100%' }}>
                {action}
            </DialogActions>
        </Dialog>
    );
}
